import {containsSquareBrackets, escapeSquareBrackets} from "./string";
import {isPlainObject} from "./object";

export default function generateValidationMarkup(validationResult = []) {

    let markup = [];

    //markup.push(`<div class="text-danger"><h2>Please fix these issues - </h2><ol>`);

    markup.push(`<ol>`);

    validationResult.forEach(function (item) {

        if(containsSquareBrackets(item.name)) {
            item.name = escapeSquareBrackets(item.name);
        }

        markup.push(`<li>
 <a href="#" class="scroller text-danger text-decoration-none d-block" data-target="[data-block=${item.name}]">${item.message}</a>
</li>`);

    });

    markup.push('</ol>');

    return markup.join('');

}

export function transformValidationResultToArray(validationResult = {}) {

    if(!isPlainObject(validationResult)) {
        return [];
    }

    let temp = [];

    for (const resultKey in validationResult) {

        if(!validationResult.hasOwnProperty(resultKey)) {
            continue;
        }

        temp.push({
            name : resultKey,
            message : validationResult[resultKey]
        })

    }

    return temp;

}